<div class="blanko-dokumente-container">
  <div class="col-xl-10">
    <h1 class="title" appTranslationModal [translate]="'RECHTLICHES.TITLE'"></h1>
    <br />
  </div>
  <app-content-card>
    <form [formGroup]="answerFormGroup">
      <div class="row">
        <div class="col-12">
          <div class="row pb-4" id="Rechtliche Hinweise" *ngIf="!juriPerson">
            <h2 class="text-primary" appTranslationModal [translate]="'RECHTLICHES.RECHTLICHE_TITLE'"></h2>
            <div class="line-wrapper-start">
              <span style="overflow: inherit; color: #006986" class="material-icons notranslate error-icon" aria-hidden="true">remove</span>
              <p appTranslationModal [translate]="'RECHTLICHES.RECHTLICHE_TEXT1'"></p>
            </div>
            <div class="line-wrapper-start">
              <span style="overflow: inherit; color: #006986" class="material-icons notranslate error-icon" aria-hidden="true">remove</span>
              <p appTranslationModal [translate]="'RECHTLICHES.RECHTLICHE_TEXT2'"></p>
            </div>
            <div class="line-wrapper-start pb-4">
              <span style="overflow: inherit; color: #006986" class="material-icons notranslate error-icon" aria-hidden="true">remove</span>
              <p appTranslationModal [translate]="'RECHTLICHES.RECHTLICHE_TEXT3'"></p>
            </div>

            <app-checkbox [checkBoxControl]="answerFormGroup.controls['hinweise']"
              data-cy="natPerson_rechtliche-hinweise">
              <p appTranslationModal [translate]="'RECHTLICHES.RECHTLICHE_CHECKBOX_TEXT'"></p>
            </app-checkbox>
          </div>

          <div class="row pb-4" id="Rechtliche Hinweise" *ngIf="juriPerson">
            <h2 class="text-primary" appTranslationModal [translate]="'RECHTLICHES.JURRECHTLICHE_TITLE'"></h2>
            <div class="line-wrapper-start">
              <span style="overflow: inherit; color: #006986" class="material-icons notranslate error-icon" aria-hidden="true">remove</span>
              <p appTranslationModal [translate]="'RECHTLICHES.JURTEXT1'"></p>
            </div>
            <div class="line-wrapper-start">
              <span style="overflow: inherit; color: #006986" class="material-icons notranslate error-icon" aria-hidden="true">remove</span>
              <p appTranslationModal [translate]="'RECHTLICHES.JURTEXT2'"></p>
            </div>
            <div class="line-wrapper-start pb-4">
              <span style="overflow: inherit; color: #006986" class="material-icons notranslate error-icon" aria-hidden="true">remove</span>
              <p appTranslationModal [translate]="'RECHTLICHES.JURTEXT3'"></p>
            </div>

            <app-checkbox [checkBoxControl]="answerFormGroup.controls['hinweise']"
              data-cy="jurPerson_rechliche-hinweise">
              <p appTranslationModal [translate]="'RECHTLICHES.JURTEXT4'"></p>
            </app-checkbox>
          </div>

          <div *ngIf="!juriPerson" class="row pb-4" id="selbstauskunft">
            <h2 class="text-primary" appTranslationModal [translate]="'RECHTLICHES.SELBSTAUSKUNFT_TITLE'"></h2>

            <app-checkbox [checkBoxControl]="answerFormGroup.controls['nurDeSteuerpflicht']"
              data-cy="natPerson_selbstauskunft1">
              <p appTranslationModal [translate]="'RECHTLICHES.SELBSTAUSKUNFT_CHECKBOX1_TEXT'"></p>
            </app-checkbox>

            <app-checkbox [checkBoxControl]="answerFormGroup.controls['usSteuerpflicht']"
              data-cy="natPerson_selbstauskunft2">
              <p appTranslationModal [translate]="'RECHTLICHES.SELBSTAUSKUNFT_CHECKBOX2_TEXT'"></p>
            </app-checkbox>
          </div>

          <div *ngIf="juriPerson" class="row pb-4" id="selbstauskunft">
            <h2 class="text-primary" appTranslationModal [translate]="'RECHTLICHES.JURTEXT5'"></h2>
            <div class="line-wrapper-start">
              <span style="overflow: inherit; color: #006986" class="material-icons notranslate error-icon" aria-hidden="true">remove</span>
              <p appTranslationModal [translate]="'RECHTLICHES.JURTEXT6'"></p>
            </div>

            <div class="line-wrapper-start">
              <span style="overflow: inherit; color: #006986" class="material-icons notranslate error-icon" aria-hidden="true">remove</span>
              <p appTranslationModal [translate]="'RECHTLICHES.JURTEXT7'"></p>
            </div>

            <div class="line-wrapper-start">
              <span style="overflow: inherit; color: #006986" class="material-icons notranslate error-icon" aria-hidden="true">remove</span>
              <p appTranslationModal [translate]="'RECHTLICHES.JURTEXT8'"></p>
            </div>

            <div class="line-wrapper-start">
              <span style="overflow: inherit; color: #006986" class="material-icons notranslate error-icon" aria-hidden="true">remove</span>
              <p appTranslationModal [translate]="'RECHTLICHES.JURTEXT9'"></p>
            </div>

            <br /><br /><br />

            <app-checkbox [checkBoxControl]="answerFormGroup.controls['nurDeSteuerpflicht']"
              data-cy="jurPerson_selbstauskunft">
              <p appTranslationModal [translate]="'RECHTLICHES.JURTEXT10'"></p>
            </app-checkbox>
          </div>

          <div *ngIf="!juriPerson" class="row pb-4" id="agbs">
            <h2 class="text-primary" appTranslationModal [translate]="'RECHTLICHES.ALLGEMEINE_TITLE'"></h2>
            <app-accordion>
              <app-expansion-panel>
                <app-expansion-panel-header>
                  <app-panel-title class="text-bold">
                    <p appTranslationModal [translate]="'RECHTLICHES.ALLGEMEINE_AGB_TITLE'"></p>
                  </app-panel-title>
                </app-expansion-panel-header>
                <table cdk-table [dataSource]="agbDataSource" class="full-width">
                  <ng-container cdkColumnDef="name">
                    <td cdk-cell *cdkCellDef="let element">
                      <h3 style="word-break: break-word">{{ element.name }}</h3>
                    </td>
                  </ng-container>
                  <ng-container cdkColumnDef="download">
                    <td cdk-cell class="text-right" *cdkCellDef="let element">
                      <button class="search-button" (click)="openRechtlichesDocument(element.position)"
                        data-cy="natPerson_search-icon">
                        <span class="material-icons notranslate" aria-hidden="true">search</span>
                      </button>
                    </td>
                  </ng-container>

                  <tr cdk-row *cdkRowDef="let row; columns: displayedColumns"></tr>
                </table>
              </app-expansion-panel>
            </app-accordion>

            <app-checkbox [checkBoxControl]="answerFormGroup.controls['agbs']" data-cy="natPerson_agbs">
              <p appTranslationModal [translate]="'RECHTLICHES.ALLGEMEINE_CHECKBOX_TEXT'"></p>
            </app-checkbox>
          </div>

          <div *ngIf="!juriPerson" class="row pb-4" id="datenschutzhinweise">
            <h2 class="text-primary" appTranslationModal [translate]="'RECHTLICHES.DATENSCHUTZWEISE_TITLE'"></h2>
            <table cdk-table [dataSource]="datenschutzDataSource" class="full-width">
              <ng-container cdkColumnDef="name">
                <td cdk-cell *cdkCellDef="let element" style="padding-left: 0">
                  <h3>{{ element.name }}</h3>
                </td>
              </ng-container>
              <ng-container cdkColumnDef="download">
                <td cdk-cell class="d-flex justify-content-end" *cdkCellDef="let element">
                  <button class="search-button" (click)="openRechtlichesDocument(element.position)"
                    data-cy="natPerson_search-icon">
                    <span class="material-icons notranslate" aria-hidden="true">search</span>
                  </button>
                </td>
              </ng-container>

              <tr cdk-row *cdkRowDef="let row; columns: displayedColumns" class="btn-text"></tr>
            </table>

            <app-checkbox [checkBoxControl]="answerFormGroup.controls['datenschutz']" data-cy="natPerson_datenschutz">
              <p appTranslationModal [translate]="'RECHTLICHES.DATENSCHUTZWEISE_CHECKBOX_TEXT'"></p>
            </app-checkbox>
          </div>

          <!-- Einwilligung -->
          <div class="row pb-4" *ngFor="let c of consentOptionsForDataCategories; trackBy: trackByConsentCategoryId"
            [id]="c.id">
            <ng-container [ngSwitch]="c.level">
              <h2 *ngSwitchCase="2" class="text-primary" appTranslationModal [translate]="c.title"></h2>
              <h4 *ngSwitchDefault class="text-primary" appTranslationModal [translate]="c.title"></h4>
            </ng-container>

            <app-accordion>
              <app-expansion-panel>
                <app-expansion-panel-header>
                  <app-panel-title class="text-bold">
                    <p appTranslationModal [translate]="c.title"></p>
                  </app-panel-title>
                </app-expansion-panel-header>

                <table cdk-table [dataSource]="einwilligungDataSource" class="full-width">
                  <ng-container cdkColumnDef="name">
                    <td cdk-cell *cdkCellDef="let element">
                      <p class="legal-text" lang="de" appTranslationModal [translate]="c.sub"></p>
                    </td>
                  </ng-container>

                  <ng-container cdkColumnDef="download">
                    <td cdk-cell *cdkCellDef="let element"></td>
                  </ng-container>

                  <tr cdk-row *cdkRowDef="let row; columns: displayedColumns"></tr>
                </table>
              </app-expansion-panel>
            </app-accordion>

            <app-checkbox *ngIf="c.showCheckbox === true" [checkBoxControl]="answerFormGroup.controls[c.control]"
              [attr.data-cy]="'natPerson_datenschutz_' + c.key">
              <p appTranslationModal [translate]="c.checkboxText"></p>
            </app-checkbox>
          </div>
          <!-- End Einwilligungen -->

          <div *ngIf="!juriPerson" class="row pb-4" id="pep">
            <h2 class="text-primary" appTranslationModal [translate]="'RECHTLICHES.ERKLAERUNG_TITLE'"></h2>
            <div class="line-wrapper-start pb-4">
              <p appTranslationModal [translate]="'RECHTLICHES.ERKLAERUNG_TEXT'"></p>
            </div>

            <div [formGroup]="answerFormGroup" class="radio-pep">
              <input type="radio" formControlName="offentlichesAmt" [value]="false"
                data-cy="jurPerson_pep-radiobutton1" />
              <p appTranslationModal [translate]="'RECHTLICHES.ERKLAERUNG_RADIO1_TEXT'"></p>

              <input type="radio" formControlName="offentlichesAmt" [value]="true"
                data-cy="jurPerson_pep-radiobutton2" />
              <p appTranslationModal [translate]="'RECHTLICHES.ERKLAERUNG_RADIO2_TEXT'"></p>
            </div>

            @if (answerFormGroup.get('offentlichesAmt')?.value === true) {
            <app-inputtext [control]="answerFormGroup.controls['offentlichesAmtField'].value" [label]="'Amt Angaben'"
              [readonly]="false"></app-inputtext>
            }
          </div>

          <div *ngIf="!juriPerson" class="row pb-4" id="einlagensicherung">
            <h2 class="text-primary" appTranslationModal [translate]="'RECHTLICHES.HINWEIS_TITLE'"></h2>
            <p appTranslationModal [translate]="'RECHTLICHES.HINWEIS_TEXT'"></p>
            <table cdk-table [dataSource]="infoEinlegerDataSource" class="full-width">
              <ng-container cdkColumnDef="name">
                <td cdk-cell *cdkCellDef="let element">
                  <h3>{{ element.name }}</h3>
                </td>
              </ng-container>
              <ng-container cdkColumnDef="download">
                <td cdk-cell class="text-right" *cdkCellDef="let element">
                  <button class="search-button" (click)="openRechtlichesDocument(element.position)"
                    data-cy="natPerson_search-icon">
                    <span class="material-icons notranslate" aria-hidden="true">search</span>
                  </button>
                </td>
              </ng-container>

              <tr cdk-row *cdkRowDef="let row; columns: displayedColumns"></tr>
            </table>

            <app-checkbox [checkBoxControl]="answerFormGroup.controls['einlagensicherung']"
              data-cy="natPerson_einlagensicherung">
              <p appTranslationModal [translate]="'RECHTLICHES.HINWEIS_CHECKBOX_TEXT'"></p>
            </app-checkbox>
          </div>

          <div *ngIf="juriPerson" class="row pb-4" id="agbs">
            <h2 class="text-primary" appTranslationModal [translate]="'RECHTLICHES.JURTEXT11'"></h2>
            <app-accordion>
              <app-expansion-panel>
                <app-expansion-panel-header>
                  <app-panel-title class="text-bold">
                    <p appTranslationModal [translate]="'RECHTLICHES.JURTEXT12'"></p>
                  </app-panel-title>
                </app-expansion-panel-header>
                <table cdk-table [dataSource]="agbDataSource" class="full-width">
                  <ng-container cdkColumnDef="name">
                    <td cdk-cell *cdkCellDef="let element">
                      <h3 style="word-break: break-word">{{ element.name }}</h3>
                    </td>
                  </ng-container>
                  <ng-container cdkColumnDef="download">
                    <td cdk-cell class="text-right" *cdkCellDef="let element">
                      <button type="button" class="search-button" (click)="openRechtlichesDocument(element.position)"
                        data-cy="jurPerson_search-icon">
                        <span class="material-icons notranslate" aria-hidden="true">search</span>
                      </button>
                    </td>
                  </ng-container>

                  <tr cdk-row *cdkRowDef="let row; columns: displayedColumns"></tr>
                </table>
              </app-expansion-panel>
            </app-accordion>

            <app-checkbox [checkBoxControl]="answerFormGroup.controls['agbs']" data-cy="jurPerson_agbs">
              <p appTranslationModal [translate]="'RECHTLICHES.JURTEXT13'"></p>
            </app-checkbox>
          </div>

          <div *ngIf="juriPerson" class="row pb-4" id="datenschutzhinweise">
            <h2 class="text-primary" appTranslationModal [translate]="'RECHTLICHES.JURTEXT14'"></h2>
            <table cdk-table [dataSource]="datenschutzDataSource" class="full-width">
              <ng-container cdkColumnDef="name">
                <td cdk-cell *cdkCellDef="let element" style="padding-left: 0">
                  <h3>{{ element.name }}</h3>
                </td>
              </ng-container>
              <ng-container cdkColumnDef="download">
                <td cdk-cell class="d-flex justify-content-end" *cdkCellDef="let element">
                  <button type="button" class="search-button" (click)="openRechtlichesDocument(element.position)"
                    data-cy="jurPerson_search-icon">
                    <span class="material-icons notranslate" aria-hidden="true">search</span>
                  </button>
                </td>
              </ng-container>

              <tr cdk-row *cdkRowDef="let row; columns: displayedColumns"></tr>
            </table>

            <app-checkbox [checkBoxControl]="answerFormGroup.controls['datenschutz']" data-cy="jurPerson_datenschutz">
              <p appTranslationModal [translate]="'RECHTLICHES.JURTEXT150'"></p>
            </app-checkbox>
          </div>

          <div *ngIf="juriPerson" class="row pb-4" id="pep">
            <h2 class="text-primary" appTranslationModal [translate]="'RECHTLICHES.JURTEXT15'"></h2>
            <div class="line-wrapper-start pb-4">
              <p appTranslationModal [translate]="'RECHTLICHES.JURTEXT16'"></p>
            </div>
            <!-- <mat-radio-group formControlName="offentlichesAmt" (change)="radioPepValidate()"> -->
            <div [formGroup]="answerFormGroup" class="radio-pep">
              <input type="radio" formControlName="offentlichesAmt" [value]="false"
                data-cy="jurPerson_pep-radiobutton1" />
              <p appTranslationModal [translate]="'RECHTLICHES.JURTEXT17'"></p>

              <input type="radio" formControlName="offentlichesAmt" [value]="true"
                data-cy="jurPerson_pep-radiobutton2" />
              <p appTranslationModal [translate]="'RECHTLICHES.JURTEXT18'"></p>
            </div>

            @if (answerFormGroup.get('offentlichesAmt')?.value === true) {
            <app-inputtext [control]="answerFormGroup.controls['offentlichesAmtField'].value" [label]="'Amt Angaben'"
              [readonly]="false"></app-inputtext>
            }
          </div>

          <div *ngIf="juriPerson" class="row pb-4" id="einlagensicherung">
            <h2 class="text-primary" appTranslationModal [translate]="'RECHTLICHES.JURTEXT19'"></h2>
            <p appTranslationModal [translate]="'RECHTLICHES.JURTEXT20'"></p>
            <table cdk-table [dataSource]="infoEinlegerDataSource" class="full-width">
              <ng-container cdkColumnDef="name">
                <td cdk-cell *cdkCellDef="let element" style="padding-left: 0">
                  <h3>{{ element.name }}</h3>
                </td>
              </ng-container>
              <ng-container cdkColumnDef="download">
                <td cdk-cell class="d-flex justify-content-end" *cdkCellDef="let element">
                  <button type="button" class="search-button" (click)="openRechtlichesDocument(element.position)"
                    data-cy="jurPerson_search-icon">
                    <span class="material-icons notranslate" aria-hidden="true">search</span>
                  </button>
                </td>
              </ng-container>

              <tr cdk-row *cdkRowDef="let row; columns: displayedColumns"></tr>
            </table>

            <app-checkbox [checkBoxControl]="answerFormGroup.controls['einlagensicherung']"
              data-cy="jurPerson_einlagensicherung">
              <p appTranslationModal [translate]="'RECHTLICHES.JURTEXT21'"></p>
            </app-checkbox>
          </div>

          <div *ngIf="!juriPerson" class="row pb-4" id="schufaZustimmung">
            <h2 class="text-primary" appTranslationModal [translate]="'RECHTLICHES.SCHUFA_TITLE'"></h2>

            <p appTranslationModal [translate]="'RECHTLICHES.SCHUFA_TEXT'"></p>

            <app-checkbox [checkBoxControl]="answerFormGroup.controls['schufaZustimmung']"
              data-cy="natPerson_schufa-zustimmung">
              <p appTranslationModal [translate]="'RECHTLICHES.SCHUFA_CHECKBOX_TEXT'"></p>
            </app-checkbox>
          </div>

          <div *ngIf="juriPerson" class="row pb-4" id="schufaZustimmung">
            <h2 class="text-primary" appTranslationModal [translate]="'RECHTLICHES.JURTEXT22'"></h2>

            <p appTranslationModal [translate]="'RECHTLICHES.JURTEXT23'"></p>

            <app-checkbox [checkBoxControl]="answerFormGroup.controls['schufaZustimmung']"
              data-cy="jurPerson_schufa-zustimmung">
              <p appTranslationModal [translate]="'RECHTLICHES.JURTEXT24'"></p>
            </app-checkbox>
          </div>
        </div>
      </div>
    </form>
  </app-content-card>

  <div class="col-xl-9 line-wrapper mt-2" *ngIf="!answerFormGroup.valid">
    <span style="overflow: inherit" class="material-icons notranslate error-icon odfincolor" aria-hidden="true">error</span>
    <p appTranslationModal [translate]="'RECHTLICHES.CHECKBOX_BESTAETIGUNG_TEXT'"></p>
  </div>

  <div class="col-xl-9 ps-5">
    <ng-container *ngFor="let control of answerFormGroup.controls | keyvalue">
      <div class="d-flex" *ngIf="!control.value.valid">
        <p style="color: red" appTranslationModal [translate]="getControlTranslationKey(control.key)"></p>
      </div>
    </ng-container>
    <app-button color="primary" (click)="adminCheckAll()" *ngIf="isAdmin" class="pt-2">
      {{ 'RECHTLICHES.CHECK_ALL' | translate }}
      <span class="material-icons notranslate" aria-hidden="true">check</span>
    </app-button>
  </div>

  <app-separator></app-separator>
  <app-button (click)="btnService.handleSaveAndDisableButton()"
    [disabled]="btnService.isButtonDisabled() || btnService.isSaveAndContinueDisabled" data-cy="button-next">
    <span class="button-size-big" appTranslationModal [translate]="questionService.getNextButtonTitle()"></span>
  </app-button>

  <app-separator></app-separator>
</div>